// @ts-nocheck
import { canAddToCart } from "@store/Extensions/Store/Data/Products/ProductsSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useCanAddToCart = convertSelectorToHook(canAddToCart);
